import BaseModel from '@/app-core/lib/data/model/BaseModel'
import CustomerInfoValidator from '@/app-core/api/validations/customer/CustomerInfoValidator'
import CustomerInfoResource from '@/app-core/api/resources/customer/CustomerInfoResource'
import {getRegionCodeForCountryCode, parsePhoneNumber} from 'awesome-phonenumber'

export default class CustomerInfoModel extends BaseModel {
  constructor(payload = {}, resource = CustomerInfoResource, validator = CustomerInfoValidator) {
    super(payload, resource, validator)
  }

  /* PROPERTIES */
  get PhoneInternational() {
    const regionCode = getRegionCodeForCountryCode(this.PhonePrefix || '30')
    return parsePhoneNumber(this.Phone, {regionCode: regionCode || 'GR'}).number.international
  }

  boot() {
    super.boot()

    this.guarded = []
  }

  /* METHODS */
}
